import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "jobs-panel-search" }
const _hoisted_2 = { class: "jobs-panel-search__header" }
const _hoisted_3 = { class: "jobs-panel-search__header-inputs" }
const _hoisted_4 = { class: "jobs-panel-search__header-inputs-item" }
const _hoisted_5 = { class: "jobs-panel-search__header-inputs-item" }
const _hoisted_6 = { class: "jobs-panel-search__row jobs-panel-search__row--chips" }
const _hoisted_7 = { class: "jobs-panel-search__chips" }
const _hoisted_8 = { class: "jobs-panel-search__chip-count" }
const _hoisted_9 = { class: "jobs-panel-search__chip-count" }
const _hoisted_10 = { class: "jobs-panel-search__filter" }
const _hoisted_11 = { class: "jobs-panel-search-filter" }
const _hoisted_12 = { class: "jobs-panel-search-filter__item" }
const _hoisted_13 = { class: "jobs-panel-search-filter__item" }
const _hoisted_14 = { class: "jobs-panel-search-filter__item" }
const _hoisted_15 = { class: "jobs-panel-search-filter__item" }
const _hoisted_16 = {
  key: 0,
  class: "jobs-panel-search__tags"
}
const _hoisted_17 = { class: "jobs-panel-search__tags-item-name" }

import {
	computed,
	onMounted,
	ref,
	watch
} from "vue";
import {useRoute, useRouter} from "vue-router";
import {jobsStore, JobsContextType} from "@/store/jobs";
import {searchStore} from "@/store/search";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppSelect from "@/components/ui-kit/select/AppSelect.vue";
import {workerStore} from "@/store/worker";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import CreateEditJobDropdown from "@/components/main/jobs-panel/dropdowns/CreateEditJobDropdown.vue";
import AppTagSelector from "@/components/ui-kit/tag-selector/AppTagSelector.vue";
import AppRadioButton from "@/components/ui-kit/radio-button/AppRadioButton.vue";
import {useJobWorkerOptions} from "@/composables/useJobWorkerOptions";
import {TagEntityType} from "@/models/etc/types";
import type {TagWithFrequency} from "@/models/interfaces/tags/tag-models";
import {clientPageStore} from "@/store/client-page";
import {projectPageStore} from "@/store/project-page";
import { i18n } from "@/i18n";

const listGetCount = 30

export default /*@__PURE__*/_defineComponent({
  __name: 'JobsPanelSearch',
  setup(__props) {

const t = (key: string): string => String(i18n.global.t(key))

const store = jobsStore()
const userStore = workerStore()
const clientStore = clientPageStore()
const projectStore = projectPageStore()
const route = useRoute()
const router = useRouter()
const searchStoreInstance = searchStore()

const currentContext = computed<{ type: JobsContextType; entityId: number | null }>(() => {
	const id = route.query.id != null && route.query.id !== ''
		? Number(route.query.id)
		: null

	if (route.query.page === 'client' && id) {
		return {
			type: 'client', entityId: id
		}
	}

	if (route.query.page === 'project' && id) {
		return {
			type: 'project', entityId: id
		}
	}

	return { type: 'main', entityId: null }
})

const isOnEntity = computed(() => currentContext.value.type !== 'main')
const isOnClient = computed(() => currentContext.value.type === 'client')
const canCreateJob = computed(() => {
	if (userStore.workerProfile?.IsAdmin) return true
	if (currentContext.value.type === 'client') {
		return clientStore.client?.JobAccess === 2
	}
	if (currentContext.value.type === 'project') {
		return projectStore.project?.JobAccess === 2
	}
	return true
})

const routeJobId = computed<number | null>(() => {
	const raw = route.query.jobId
	if (raw == null || Array.isArray(raw) || raw === '') {
		return null
	}
	const id = Number(raw)
	return Number.isFinite(id) && id > 0 ? id : null
})
const clientSearch = computed(() => store.context.clientSearch)
const holdingSearch = computed(() => store.context.holdingSearch)
const isClientFilterActive = computed(() => clientSearch.value || holdingSearch.value)

const jobsSearch = ref('')
const selectedPerson = ref<number | null>(null)
const selectedChips = ref<number[]>([])

const chips = computed(() => [
	{
		id: 1,
		name: t('job_in_progress'),
		color: '#86CED2'
	},
	{
		id: 2,
		name: t('job_state_urgent_short'),
		color: '#EE966A'
	},
])

const $createEditJobModal = ref<typeof AppResizableDropdown | null>(null)
const $tagsDropdown = ref<InstanceType<typeof AppResizableDropdown> | null>(null)
const selectedTags = ref<TagWithFrequency[]>([])
const tagsDirty = ref(false)
const counters = computed(() => store.jobsCounter)
const userForUpdateJobsList = computed(() => store.userForUpdateJobsList)
const currentUser = computed(() => userStore.workerProfile)
const searchInWork = computed(() => selectedChips.value.includes(1))
const searchIsLost = computed(() => selectedChips.value.includes(2))

// Списки исполнителей и закреплённые сверху строки — общий источник на оба селекта.
const {
	workersOptions,
	pinnedCurrentUser,
	personFilterOptions,
	personFilterPinned
} = useJobWorkerOptions()

const jobsInit = () => {
	if (currentUser.value) {
		store.getJobWorkers()
	}
}

const onSearch = () => {
	const tagIds = selectedTags.value.length ? selectedTags.value.map(t => t.Id) : null
	store.getJobs(
		jobsSearch.value,
		selectedPerson.value as number,
		tagIds,
		searchInWork.value,
		searchIsLost.value,
		listGetCount,
		0
	)
	store.getJobsCount(
		jobsSearch.value,
		selectedPerson.value as number,
		tagIds
	)
}

const onTagsUpdate = (newTags: TagWithFrequency[]) => {
	selectedTags.value = newTags
	tagsDirty.value = true
}

const onTagsDropdownClose = () => {
	if (tagsDirty.value) {
		tagsDirty.value = false
		onSearch()
	}
}

const onDropTag = (tag: TagWithFrequency) => {
	const wasLast = selectedTags.value.length === 1
	selectedTags.value = selectedTags.value.filter(t => t.Id !== tag.Id)
	if (wasLast) onSearch()
}

const loadAroundJob = async (jobId: number) => {
	const ctx = currentContext.value

	jobsSearch.value = ''
	selectedTags.value = []
	selectedChips.value = []
	tagsDirty.value = false

	store.setContext(ctx.type, ctx.entityId)
	await store.getJobsAroundOne(jobId)
	await store.getJobsCount()
}

const consumeJobNavigationRequest = async () => {
	const req = searchStoreInstance.pendingJobNavigation
	const ctx = currentContext.value
	if (!req || req.type !== ctx.type || req.entityId !== ctx.entityId) return
	searchStoreInstance.clearPendingJobNavigation()

	await loadAroundJob(req.jobId)
}

// Внешний запрос на перезагрузку списка (например, после смены этапа проекта).
const consumeJobsRefreshRequest = () => {
	const req = store.jobsRefreshRequest
	if (!req) {
		return
	}

	const ctx = currentContext.value
	if (req.type !== ctx.type || req.entityId !== ctx.entityId) {
		return
	}

	store.clearJobsRefreshRequest()
	onSearch()
}

const consumeRouteJobId = async (jobId: number) => {
	await loadAroundJob(jobId)

	const { jobId: _omit, ...rest } = route.query
	router.replace({ query: rest })
}

const applyContextAndReload = () => {
	store.clearJobsRefreshRequest()

	const req = searchStoreInstance.pendingJobNavigation
	if (req && req.type === currentContext.value.type && req.entityId === currentContext.value.entityId) {
		consumeJobNavigationRequest()
		return
	}

	store.setContext(currentContext.value.type, currentContext.value.entityId)
	if (!currentUser.value) return

	if (isOnEntity.value && routeJobId.value) {
		consumeRouteJobId(routeJobId.value)
		return
	}

	const targetUserId = 0
	if (selectedPerson.value !== targetUserId) {
		selectedPerson.value = targetUserId
	} else {
		onSearch()
	}
}

onMounted(() => {
	jobsInit()
	applyContextAndReload()
})

watch(
	() => searchStoreInstance.pendingJobNavigation,
	() => consumeJobNavigationRequest()
)

watch(
	() => store.jobsRefreshRequest,
	() => consumeJobsRefreshRequest()
)

watch(currentUser, (newValue, oldValue) => {
	if (newValue && !oldValue) {
		jobsInit()
		applyContextAndReload()
	}
})

watch(currentContext, (newValue, oldValue) => {
	if (newValue.type !== oldValue?.type || newValue.entityId !== oldValue?.entityId) {
		selectedTags.value = []
		tagsDirty.value = false
		applyContextAndReload()
	}
})

watch(selectedPerson, (newValue, oldValue) => {
	if (newValue !== oldValue && newValue != null) {
		onSearch()
	}
})

watch(userForUpdateJobsList, (newValue, oldValue) => {
	if (newValue && !oldValue) {
		selectedPerson.value = newValue
		jobsSearch.value = ''
		onSearch()
		store.setUserForUpdateJobsList(null)
	}
})

const onClientSearchChange = (value: boolean | null) => {
	if (value == null || value === clientSearch.value) {
		return
	}
	store.setClientSearch(value)
	onSearch()
}

const onHoldingSearchChange = (value: boolean | null) => {
	if (value == null || value === holdingSearch.value) {
		return
	}
	store.setHoldingSearch(value)
	onSearch()
}

const toggleChip = (id: number) => {
	if (selectedChips.value.includes(id)) {
		selectedChips.value.splice(selectedChips.value.indexOf(id), 1)
	} else {
		selectedChips.value.push(id)
	}

	onSearch()
}

const isChipActive = (id: number) => selectedChips.value.includes(id)

const chipStyle = (t: any) => {
	if (!isChipActive(t.id)) {
		return {}
	}

	return {
		backgroundImage: `linear-gradient(to right, transparent 2px, ${hexToRgba(t.color, 0.121)} 2px)`
	}
}

const chipColoredStyle = (t: any) => {
	return {
		backgroundColor: t.color
	}
}

const hexToRgba = (hex: string, alpha: number) => {
	const res = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	if (!res) return hex;
	const r = parseInt(res[1], 16);
	const g = parseInt(res[2], 16);
	const b = parseInt(res[3], 16);
	return `rgba(${r},${g},${b},${alpha})`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppResizableDropdown, {
        ref_key: "$tagsDropdown",
        ref: $tagsDropdown,
        position: "left",
        "close-by-click-outside": true,
        "max-width": 640,
        "max-height": 436,
        "mobile-title": _ctx.$t('choose_tags'),
        name: "$jobsPanelTags",
        onClose: onTagsDropdownClose
      }, {
        activator: _withCtx(() => [
          _createVNode(AppTooltip, {
            position: "bottom",
            text: _ctx.$t('ui_tag_filter')
          }, {
            activator: _withCtx(() => [
              _createVNode(AppIcon, {
                class: "jobs-panel-search__add-btn",
                name: "hash",
                width: "20px",
                color: "#979797",
                "hover-color": "#499259",
                cursor: "pointer"
              })
            ]),
            _: 1
          }, 8, ["text"])
        ]),
        default: _withCtx(() => [
          _createVNode(AppTagSelector, {
            "model-value": selectedTags.value,
            "entity-type": _unref(TagEntityType).Job,
            mode: "filter",
            "onUpdate:modelValue": onTagsUpdate,
            onClose: _cache[0] || (_cache[0] = ($event: any) => ($tagsDropdown.value?.close()))
          }, null, 8, ["model-value", "entity-type"])
        ]),
        _: 1
      }, 8, ["mobile-title"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(AppSelect, {
            modelValue: selectedPerson.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedPerson).value = $event)),
            placeholder: _ctx.$t('select_user_placeholder'),
            items: _unref(personFilterOptions),
            "pinned-items": _unref(personFilterPinned),
            "min-dropdown-width": 272,
            "description-key": "status",
            searchable: ""
          }, null, 8, ["modelValue", "placeholder", "items", "pinned-items"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(AppInput, {
            modelValue: jobsSearch.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((jobsSearch).value = $event)),
            placeholder: _ctx.$t('search_short'),
            "show-search-button": "",
            onPressEnter: onSearch,
            onSearch: onSearch,
            onClearField: onSearch
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ]),
      (canCreateJob.value)
        ? (_openBlock(), _createBlock(AppResizableDropdown, {
            key: 0,
            position: "right",
            resizable: "",
            "initial-width": 320,
            "initial-height": 398,
            "min-width": 320,
            "max-width": 480,
            "min-height": 398,
            "max-height": 600,
            "close-by-click-outside": false,
            "hide-by-parent-scroll": false,
            "mobile-title": _ctx.$t('job_create_title'),
            ref_key: "$createEditJobModal",
            ref: $createEditJobModal,
            name: "$createEditJobModal"
          }, {
            activator: _withCtx(() => [
              _createVNode(AppTooltip, {
                position: "top",
                text: _ctx.$t('job_create')
              }, {
                activator: _withCtx(() => [
                  _createVNode(AppIcon, {
                    class: "jobs-panel-search__add-btn",
                    name: "plus-bold",
                    width: "22px",
                    color: "#979797",
                    "hover-color": "#499259",
                    cursor: "pointer"
                  })
                ]),
                _: 1
              }, 8, ["text"])
            ]),
            default: _withCtx(() => [
              _createVNode(CreateEditJobDropdown, {
                type: "create",
                workers: _unref(workersOptions),
                "pinned-workers": _unref(pinnedCurrentUser),
                onOnClose: _cache[3] || (_cache[3] = ($event: any) => ($createEditJobModal.value?.close()))
              }, null, 8, ["workers", "pinned-workers"])
            ]),
            _: 1
          }, 8, ["mobile-title"]))
        : (_openBlock(), _createBlock(AppIcon, {
            key: 1,
            class: "jobs-panel-search__add-btn",
            name: "plus-bold",
            width: "22px",
            color: "#D2D2D2"
          }))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: _normalizeClass({
						'jobs-panel-search__chip': true,
						'jobs-panel-search__chip--active': isChipActive(chips.value[0].id),
					}),
          style: _normalizeStyle(chipStyle(chips.value[0])),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleChip(chips.value[0].id)))
        }, [
          _createElementVNode("div", {
            class: "jobs-panel-search__chip-colored",
            style: _normalizeStyle(chipColoredStyle(chips.value[0]))
          }, null, 4),
          _createElementVNode("div", _hoisted_8, _toDisplayString(`${chips.value[0].name}: ${counters.value?.Actual || 0}`), 1)
        ], 6),
        _createElementVNode("div", {
          class: _normalizeClass({
						'jobs-panel-search__chip': true,
						'jobs-panel-search__chip--active': isChipActive(chips.value[1].id),
					}),
          style: _normalizeStyle(chipStyle(chips.value[1])),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleChip(chips.value[1].id)))
        }, [
          _createElementVNode("div", {
            class: "jobs-panel-search__chip-colored",
            style: _normalizeStyle(chipColoredStyle(chips.value[1]))
          }, null, 4),
          _createElementVNode("div", _hoisted_9, _toDisplayString(`${chips.value[1].name}: ${counters.value?.Lost || 0}`), 1)
        ], 6)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (isOnClient.value)
          ? (_openBlock(), _createBlock(AppResizableDropdown, {
              key: 0,
              position: "right",
              "close-by-click-outside": true,
              "mobile-title": _ctx.$t('filters'),
              name: "$jobsPanelFilter"
            }, {
              activator: _withCtx(() => [
                _createVNode(AppTooltip, {
                  position: "top",
                  text: _ctx.$t('filters')
                }, {
                  activator: _withCtx(() => [
                    _createVNode(AppIcon, {
                      name: "filter",
                      width: "18px",
                      color: isClientFilterActive.value ? '#499259' : '#979797',
                      "hover-color": "#499259",
                      cursor: "pointer"
                    }, null, 8, ["color"])
                  ]),
                  _: 1
                }, 8, ["text"])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(AppRadioButton, {
                      "model-value": clientSearch.value,
                      "radio-value": false,
                      name: "jobsClientSearch",
                      text: _ctx.$t('job_filter_in_projects'),
                      "onUpdate:modelValue": onClientSearchChange
                    }, null, 8, ["model-value", "text"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(AppRadioButton, {
                      "model-value": clientSearch.value,
                      "radio-value": true,
                      name: "jobsClientSearch",
                      text: _ctx.$t('job_filter_client_only'),
                      "onUpdate:modelValue": onClientSearchChange
                    }, null, 8, ["model-value", "text"])
                  ]),
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "jobs-panel-search-filter__divider" }, null, -1)),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(AppRadioButton, {
                      "model-value": holdingSearch.value,
                      "radio-value": false,
                      name: "jobsHoldingSearch",
                      text: _ctx.$t('job_filter_current_client'),
                      "onUpdate:modelValue": onHoldingSearchChange
                    }, null, 8, ["model-value", "text"])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(AppRadioButton, {
                      "model-value": holdingSearch.value,
                      "radio-value": true,
                      name: "jobsHoldingSearch",
                      text: _ctx.$t('job_filter_holding_clients'),
                      "onUpdate:modelValue": onHoldingSearchChange
                    }, null, 8, ["model-value", "text"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["mobile-title"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (selectedTags.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTags.value, (tag) => {
            return (_openBlock(), _createElementBlock("div", {
              key: tag.Id,
              class: "jobs-panel-search__tags-item"
            }, [
              _createElementVNode("div", _hoisted_17, _toDisplayString(tag.Name), 1),
              _createVNode(AppIcon, {
                class: "jobs-panel-search__tags-item-delete",
                name: "close-bold",
                width: "12px",
                color: "#D2D2D2",
                "hover-color": "#4D4D4D",
                cursor: "pointer",
                onClick: _withModifiers(($event: any) => (onDropTag(tag)), ["stop"])
              }, null, 8, ["onClick"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})